"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const sitetext_1 = require("../filters/sitetext");
const ChallengeStatus_1 = require("../enums/ChallengeStatus");
exports.default = vue_1.default.extend({
    name: 'remember-device',
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        toggleRememberStatus() {
            this.rememberDevice = !this.rememberDevice;
        },
    },
    computed: {
        hasError() {
            return this.$store.getters.challengeStatus === ChallengeStatus_1.ChallengeStatus.DeviceNameAlreadyExists ? true : false;
        },
        errorText() {
            return this.$store.getters.challengeStatus === ChallengeStatus_1.ChallengeStatus.DeviceNameAlreadyExists ? this.getSiteText('RDM.DeviceAlreadyExists') : '';
        },
        canRememberDevice() {
            return this.$store.getters.canRememberDevice;
        },
        rememberDevice: {
            get() {
                return this.$store.getters.rememberDevice;
            },
            set(newValue) {
                this.$store.commit('setRememberDevice', newValue);
            },
        },
        deviceName: {
            get() {
                return this.$store.getters.deviceName;
            },
            set(newValue) {
                this.$store.commit('setDeviceName', newValue);
            },
        },
        showMandatory2faMessage() {
            return !this.$store.getters.canRememberDevice && this.$store.getters.isStepUpMandatory;
        },
    },
});
